module.exports = __webpack_public_path__ + "img/cosmic-cat.76dbadf1.webp";